import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=764d3060&"
import script from "./Rules.vue?vue&type=script&lang=js&"
export * from "./Rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports